// Which drawer thumbnail the outline renders.
//
// Two implementations exist side by side while the live one is on trial:
//
//   'sketch'  SlideThumbnailPreview — hand-written miniatures, one per block
//             type, capped at five blocks with a "+n" counter. Cheap, always
//             legible, but the layout is invented rather than the slide's.
//
//   'live'    SlideLiveThumbnail — the real block components rendered
//             read-only on a slide-sized stage and scaled down, so the
//             thumbnail matches the slide exactly.
//
// The switch is a localStorage key rather than a build flag so the two can be
// compared against the same deck in the same session, without a rebuild:
//
//   localStorage.setItem('lp.thumbnails', 'sketch');  // then reload
//   localStorage.removeItem('lp.thumbnails');         // back to the default
//
// Reading is defensive because localStorage throws outright in a few real
// configurations — Safari's private mode, and any embedding that blocks
// third-party storage — and a thumbnail preference is never worth a blank app.

export const THUMBNAIL_MODE_KEY = 'lp.thumbnails';

export const THUMBNAIL_MODES = ['live', 'sketch'];

/**
 * What a browser with no stored preference gets.
 *
 * 'live' while the trial is running: the point is to see it against real decks
 * without anyone having to opt in first. Flip this one constant to retreat to
 * the sketch thumbnails for everyone.
 */
export const DEFAULT_THUMBNAIL_MODE = 'live';

export const readThumbnailMode = () => {
  try {
    const stored = window.localStorage.getItem(THUMBNAIL_MODE_KEY);
    return THUMBNAIL_MODES.includes(stored) ? stored : DEFAULT_THUMBNAIL_MODE;
  } catch {
    return DEFAULT_THUMBNAIL_MODE;
  }
};

export const isLiveThumbnailMode = () => readThumbnailMode() === 'live';
